import { render, staticRenderFns } from "./CalendarModule.vue?vue&type=template&id=70445980"
import script from "./CalendarModule.vue?vue&type=script&lang=js"
export * from "./CalendarModule.vue?vue&type=script&lang=js"
import style0 from "./CalendarModule.vue?vue&type=style&index=0&id=70445980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports